import { render, staticRenderFns } from "./ContentButton.vue?vue&type=template&id=064748f4"
import script from "./ContentButton.vue?vue&type=script&lang=js"
export * from "./ContentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports